import { MessageCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const supportSubNav: RouteListItem[] = [
  {
    path: '/support/$ticket_id',
    icon: MessageCircle,
    name: 'Support Ticket Details',
  },
];
